import React from 'react';
import { Box, Container, Typography, IconButton, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import PublicIcon from '@mui/icons-material/Public'; // Using Public icon for BlueSky as there's no specific one

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'primary.main'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {new Date().getFullYear()} Astro_Vino. All rights reserved.
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              component={RouterLink}
              to="/contact"
              color="inherit"
              size="small"
              startIcon={<ContactMailIcon />}
              sx={{
                borderColor: 'rgba(245,151,79,0.45)',
                color: 'text.secondary',
                '&:hover': {
                  color: 'primary.light',
                  borderColor: 'primary.light',
                  backgroundColor: 'rgba(245,151,79,0.08)'
                }
              }}
              variant="outlined"
            >
              Contact
            </Button>
            <IconButton
              href="https://www.instagram.com/astro_vino/"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              size="large"
              sx={{
                '&:hover': {
                  color: '#E1306C' // Instagram brand color
                }
              }}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              href="https://x.com/astro_vino"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              size="large"
              sx={{
                '&:hover': {
                  color: '#1DA1F2' // Twitter brand color
                }
              }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              href="https://www.youtube.com/@astro_vino"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              size="large"
              sx={{
                '&:hover': {
                  color: '#FF0000' // YouTube brand color
                }
              }}
            >
              <YouTubeIcon />
            </IconButton>
            <IconButton
              href="https://bsky.app/profile/astrovino.bsky.social"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              size="large"
              sx={{
                '&:hover': {
                  color: '#0085FF' // BlueSky brand color
                }
              }}
            >
              <PublicIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
